module.exports = __webpack_public_path__ + "static/media/nsda_logo.279421ab.webp";